import { render, staticRenderFns } from "./VenueListItem.vue?vue&type=template&id=64c3a2e0&scoped=true&"
import script from "./VenueListItem.vue?vue&type=script&lang=ts&"
export * from "./VenueListItem.vue?vue&type=script&lang=ts&"
import style0 from "./VenueListItem.vue?vue&type=style&index=0&id=64c3a2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3a2e0",
  null
  
)

export default component.exports